import { z } from "zod";

export const invoiceSchema = z.object({
  amount: z.number().gt(0),
  date: z.coerce.date(),
  link: z.string().url(),
  orderNumber: z.string(),
  plans: z.string(),
});

export type Invoice = z.infer<typeof invoiceSchema>;
